<template>
  <section>
    <div
      class="teach-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div v-for="([amount, description], index) of amounts" :key="`${amount}_${index}`" class="amount-row">
        <input
        :id="`${amount}_${index}`"
          type="radio"
          class="amount"
          @click="
          selectedAmount = amount;
          selectedDescription = description;
"
        :checked="(selectedAmount == amount && selectedDescription == description)"
          @change="emitValue"
        />
      <FormLabel :for="`${amount}_${index}`">
          <MoneyFormat
            class="label-amount"
            :value="amount"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
        <span class="label-description" v-if="description" v-html="description"></span>
        </FormLabel>
      </div>
      <div class="amount_other__wrapper amount-row">
        <input
          id="amount_other_check"
          type="radio"
          class="amount"
          :checked="customSelected"
          @click="customSelected = true"
        />
        <input
          id="amount_other"
          type="number"
          min="1"
          name="amount_other"
          placeholder="Other"
          v-model="customAmount"
        />
      </div>
      <!-- <div class="amount-row tickets-num" v-if="selectedAmount == 100">
        <input
          v-model="numOfTickets"
          type="number"
          min="1"
          name="ticketsQnt"
          placeholder="Number of tickets"
        />
      </div> -->
      <div></div>
    </div>
    <br />
  </section>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({    emits: ["update:emittedDescription"],
  setup(props, { emit }) {
    const { setValue, form, settings, getValue } = usePaymentForm();

        const emittedDescription = ref<string | null>(null);

    const emitValue = () => {
      emit("update:emittedDescription", selectedDescription.value);
    };
        const selectedDescription = ref();

    const selectedAmount = ref();
    const codetext = ref();
    const numOfTickets = ref(1);
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const customQnt = computed(() => selectedAmount.value == 100);
    const ticketsQnt = computed(() => {
      const amount = getValue("amount");

      if (!amount || Number(amount) < 100) {
        return 0;
      }

      let ticketsQnt: number = 0;

      if (customAmount.value) {
        ticketsQnt = Math.floor(Number(amount) / 100);
      }

      if (customQnt.value) {
        ticketsQnt = +numOfTickets.value;
      }

      if ([180, 360, 500, 1000].includes(selectedAmount.value)) {
        ticketsQnt = 1;
      }

      if (selectedAmount.value == 1800) {
        ticketsQnt = 2;
      }

      if (getValue("custom.coupon") == "Teachers" && !customQnt.value) {
        ticketsQnt += 1;
        codetext.value = "50% off each ticket (with a 2 ticket limit)";
      }

      if (
        getValue("custom.coupon") == "Breakfast4" &&
        Number(amount) >= 1800 &&
        Number(amount) < 5000
      ) {
        ticketsQnt = 4;
        codetext.value = "Includes 4 free tickets";
      }

      if (getValue("custom.coupon") == "Table10" && Number(amount) >= 5000) {
        ticketsQnt = 10;
        codetext.value = "Includes 10 free tickets";
      }

      return ticketsQnt;
    });

    watch(ticketsQnt, (ticketsQnt) => {
      setValue("custom.ticketsQnt", ticketsQnt.toString());
    });

    function setAmountFromSelected() {
      if (selectedAmount.value) {
        customSelected.value = false;
        customAmount.value = null;
        if (customQnt.value) {
          if (getValue("custom.coupon") == "Teachers") {
            const undiscountedTickets = Math.max(numOfTickets.value - 2, 0);
            const discountedTickets = numOfTickets.value - undiscountedTickets;

            setValue(
              "amount",
              String(undiscountedTickets * 100 + discountedTickets * 50)
            );
          } else {
            setValue("amount", String(selectedAmount.value * numOfTickets.value));
          }
        } else {
          setValue("amount", "" + selectedAmount.value);
        }
      }
    }

    watch(() => getValue("custom.coupon"), setAmountFromSelected);

    watch([selectedAmount, numOfTickets], setAmountFromSelected);

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      clearOutSelectedValue,
      customSelected,
      numOfTickets,
      emittedDescription,
      customQnt,
      emitValue,
      codetext,
      getValue,
        selectedDescription,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 100%;
}
.label-description {
  font-weight: normal;
  padding: 0px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.teach-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
.discount__text {
  display: inline-block;
  padding: 5px 11px;
  margin-bottom: 15px;
  font-weight: 600;
  color: #3d3e40;
  font-size: 13px;
  font-style: italic;
  background: #f8f8f8;
}

</style>
